import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 430px 1fr;
	height: 100%;
`;

const StyledHeadTitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	background-color: #1ab248;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	width: fit-content;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledLeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px;
	border-right: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledInfoBlock = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	width: 100%;
	height: 80px;
	padding: 0 24px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
	}

	${Text} {
		font-style: italic;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledMembersHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 10px;
`;

const StyledMembersContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	height: 270px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledLeftButtonContainer = styled.div`
	margin-top: auto;
`;

const StyledRightContainer = styled.div`
	padding: 20px;
	height: 100%;
`;

const StyledNotActiveOrderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;

	${Text} {
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledAddFriendsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: 100%;
`;

const StyledAddFriendsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledAddFriendsItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 60px;
	min-height: 60px;
	padding: 0 20px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);

	& > ${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledNotActivePlayersList = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 468px;

	${Text} {
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

export {
	StyledAddFriendsContainer,
	StyledAddFriendsItem,
	StyledAddFriendsList,
	StyledButtonContent,
	StyledContainer,
	StyledHeadTitleContainer,
	StyledInfoBlock,
	StyledLeftButtonContainer,
	StyledLeftContainer,
	StyledMembersContainer,
	StyledMembersHead,
	StyledNotActiveOrderContainer,
	StyledNotActivePlayersList,
	StyledRightContainer,
};
